import ApiService from "./ApiService"
import { ApiServiceName, ApiLinkEntity, ApiLinkRel } from "config/constants"
import CustomError from "models/CustomError"
import { Guid } from "@/types"
import ErrorHandler from "utils/errorHandler"
import { downloadBlobAsFile } from "utils/utils"

type DownloadZipParams =
    | { fileNameWithoutExtension: string; fileIds: Guid[]; files?: undefined }
    | { fileNameWithoutExtension: string; files: { fileId: Guid; friendlyName?: string }[]; fileIds?: undefined }

class FileService {


    uploadFile<T>(file: File): Promise<T> {
        try {
            const data = new FormData()
            data.append("file", file)
            return ApiService.request({
                serviceName: ApiServiceName.file,
                followLink: {
                    entity: ApiLinkEntity.file,
                    rel: ApiLinkRel.new
                },
                data
            })
        } catch (e) {
            throw new CustomError({
                messageCode: "message.systemError"
            })
        }
    }

    async downloadZip(params: DownloadZipParams): Promise<void> {
        const { fileNameWithoutExtension, fileIds, files } = params;

        try {
            const payload = fileIds ? { fileIds } : { files };

            const blob: Blob = await ApiService.request({
                serviceName: ApiServiceName.file,
                followLink: {
                    entity: ApiLinkEntity.downloadFileZip,
                    rel: ApiLinkRel.all
                },
                data: payload,
                responseType: "blob",
            });

            downloadBlobAsFile(blob, `${fileNameWithoutExtension}.zip`);
        } catch (e) {
            ErrorHandler.handleHttpError(e);
        }
    }

}

export default new FileService()
